import $ from 'jquery'
import { gsap } from './gsap'
import { ScrollTrigger } from './ScrollTrigger'
import Swiper from 'swiper'
import SwiperCore, {Navigation, Autoplay} from 'swiper/core'
Swiper.use([Autoplay]);

global.jQuery = $
global.$ = $

require('./slow-show.js')
require('./focus-visible.js')
require('./keyboard-click.js')
require('./parallax.js')
require('./modal-maker.js')
require('./tab-tracker.js')
require('./custom-select.js')
require('./slow-show.js')
require('./fancybox/fancybox.js')
require('./inputmask/inputmask.js')

$(document).ready(function () {

  //inputmask
  $('input[type=tel]').inputmask("+7 (999) 999-99-99")

  // loader
  $('.loader').fadeOut(250)

  // vh fix
  if ( $(window).outerWidth() >= 768 ) {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  // slow-show
  if ( $(window).outerWidth() >= 768 ) {
    $('.itsm-schematic-visual-svg').slowShow({
      addClass: 'is-active',
      translate: '0%',
      start: -300
    })
    $('.anim-title').slowShow({
      addClass: 'is-active',
      translate: '100px',
      fade: true
    })
    $('.itsm-solve, .itsm-provide__triangle--1, .itsm-provide__triangle--2, .asset-schematic__deco, .itsm-provide__list, .itsm-provide__square, .footer, .itsm-tabs, .itsm-facility__content, .itsm-facility__deco, .itsm-facility-heading, .itsm-schematic__list, .cpi-download__square, .itsm-scripts, .itsm-provide__angle, .anim-letter, .itsm-tasks__list, .itsm-scripts__list, .anim-image, .itsm-solve__col--2, .itsm-solve__deco, .itsm-solve__text, .itsm-provide__list, .itsm-provide__square, .anim-letter, .itsm-tasks__list, .itsm-scripts__list, .anim-image, .itsm-solve__col--2, .itsm-solve__deco, .itsm-solve__text, .cpi-steps__text, .cpi-folder__list, .cpi-benefits__list, .cpi-how-cards-item__desc, .cpi-details__logo, .cpi-details__list, .cpi-integration-schematic__svg, .cpi-integration-schematic__list, .cpi-integration-legend, .rnd-cards__list, .rnd-schematic__text, .rnd-schematic__powered').slowShow({
      addClass: 'is-active',
      translate: '0'
    })
  } else {
    $('.itsm-solve, .itsm-schematic-visual-svg, .itsm-provide__triangle--1, .itsm-provide__triangle--2, .asset-schematic__deco, .itsm-provide__list, .itsm-provide__square, .footer, .itsm-tabs, .itsm-facility__content, .itsm-facility__deco, .itsm-facility-heading, .itsm-schematic__list, .cpi-download__square, .itsm-scripts, .itsm-provide__angle, .anim-letter, .itsm-tasks__list, .itsm-scripts__list, .anim-image, .itsm-solve__col--2, .itsm-solve__deco, .itsm-solve__text, .itsm-provide__list, .itsm-provide__square, .anim-letter, .itsm-tasks__list, .itsm-scripts__list, .anim-image, .itsm-solve__col--2, .itsm-solve__deco, .itsm-solve__text, .cpi-steps__text, .cpi-folder__list, .cpi-benefits__list, .cpi-how-cards-item__desc, .cpi-details__logo, .cpi-details__list, .cpi-integration-schematic__svg, .cpi-integration-schematic__list, .cpi-integration-legend, .rnd-cards__list, .rnd-schematic__text, .rnd-schematic__powered').addClass('is-active')
  }

  // show content
  setTimeout(
    function () {
      $('.body__wrapper').css('opacity', '').addClass('is-active')
      $('html').css('overflow', '')
    },
    100
  )

  // move letter
  $('[data-moving-box]').mousemove(function( event ) {
    let that = $(this)
    let target = that.find('[data-moving-elem]')
    let multiplier = 30
    let suspension = 15
    let containerWidth = that.innerWidth(),
      containerHeight = that.innerHeight(),
      mousePositionX = (event.pageX / containerWidth) * multiplier,
      mousePositionY = (event.pageY /containerHeight) * multiplier

    target.css({
      'transform': 'translate('+ mousePositionX + 'px,' + ' ' + mousePositionY + 'px)',
      'transition': '.'+ suspension +'s'
    })
  })

  //red round action
  let spinBox = $('[data-spinner-wrapper]')
  let spinCircle = $('[data-spinner-circle]')
  let spinRound = $('[data-spinner-round]')

  let stepItem = $('[data-step-elem]')
  let stepBox = $('[data-step-wrapper]')

  spinBox.each(function () {
    let box = $(this)
    let triggerStartPos = box.offset().top

    let speed = box.attr('data-spinner-wrapper')/10

    let rotateCurrentDeg = 0
    let triggerEndDeg = box.find(spinRound).attr('data-spinner-round')

    $(window).scroll(function () {
      let that = $(this)
      let windowH = that.outerHeight()

      let windowTopPos = that.scrollTop()
      let windowBotPos = windowTopPos + windowH

      // rotate
      if ( windowBotPos >= triggerStartPos ) {
        rotateCurrentDeg = windowBotPos - triggerStartPos

        box.find(spinRound).css({
          'transform': 'rotate('+ rotateCurrentDeg * speed +'deg)'
        })
      }

      // hide/show
      if ( rotateCurrentDeg >= triggerEndDeg * 1/speed) {
        box.find(spinRound).fadeOut(0)
        $('.cpi-steps-stair').find(stepItem).eq(0).addClass('is-active')
      } else {
        box.find(spinRound).fadeIn(0)
        $('.cpi-steps-stair').find(stepItem).eq(0).removeClass('is-active')
      }

    })
  })

  function switchStep() {
    stepBox.each(function () {
      let box = $(this)

      let windowH = $(window).outerHeight()
      let windowTopPos = $(window).scrollTop()
      let windowMidPos = windowTopPos + windowH / 2


      box.find(stepItem).each(function () {
        let that = $(this)
        let stepItemOffset = that.offset().top

        if (windowMidPos >= stepItemOffset) {
          box.find(stepItem).removeClass('is-active')
          that.addClass('is-active')
        } else {
          that.removeClass('is-active')
        }
      })
    })
  }

  function triggerNav() {
    const navBar = $('.cpi-nav-bar')
    let windowH = $(window).outerHeight()
    let windowTopPos = $(window).scrollTop()

    if (windowTopPos > windowH - 100) {
      navBar.addClass('is-active')
    } else {
      navBar.removeClass('is-active')
    }
  }

  gsap.registerPlugin(ScrollTrigger)

  $('[data-anchor-section]').each(function () {
    let that = this
    ScrollTrigger.create({
      trigger: that,
      start: 'top-=100 top+=200',
      end: 'bottom-=100 top+=200',
      onEnter: () => {
        $('[data-anchor]').removeClass('cpi-nav-bar__link--current')
        let current = $(that).attr('data-anchor-section')
        $(`[data-anchor="${current}"]`).addClass('cpi-nav-bar__link--current')
      },
      onEnterBack: () => {
        $('[data-anchor]').removeClass('cpi-nav-bar__link--current')
        let current = $(that).attr('data-anchor-section')
        $(`[data-anchor="${current}"]`).addClass('cpi-nav-bar__link--current')
      }
    })
  })

  ScrollTrigger.refresh(true)

  $(window).scroll(function () {
    switchStep()
    triggerNav()
  })

  //anchors
  $('[data-anchor]').each(function (val) {
    $(`[data-anchor="${val + 1}"`).click(e => {
      e.preventDefault()
      $('html, body').animate({scrollTop: $(`[data-anchor-section="${$(this).attr('data-anchor')}"]`).offset().top - 100}, 1000)
    })
  })

  //subnav-anchors
  $('[data-anchor-subnav]').each(function (val) {
    $(`[data-anchor-subnav="${val + 1}"`).click(e => {
      e.preventDefault()
      $('html, body').animate({scrollTop: $(`[data-anchor-section="${$(this).attr('data-anchor-subnav')}"]`).offset().top - 100}, 1000)
    })
  })

  $('.main-about-video__play-btn').click(function () {
    $(this).css({ display: 'none' })
    $('.main-about-video__preview').css({ display: 'none' })
    document.querySelector('.main-about-video__video').play()
  })

  $('.cpi-nav-bar-logo').click(function () {
    $('html, body').animate({scrollTop: 0}, 1000)
  })


  // folder
  $('.folder__trigger').click(function () {
    $(this).parents('.folder').toggleClass('is-active').find('.folder__content').slideToggle("slow", function() {});
    ScrollTrigger.refresh(true)
  })
  $('.folder').not('.is-active').find('.folder__content').css('display', 'none')

  // cpi-rnd
  $('.cpi-integration-schematic-item').click(function () {
    let that = $(this)
    let text = that.find('.cpi-integration-schematic-item__text')

    that.toggleClass('is-active')

    if ( that.hasClass('is-active') ) {
      text.fadeIn(500)
    } else {
      text.fadeOut(0)
    }
  })

  // rnd bind
  const schFrom= 'data-sch-from'
  const schTo= 'data-sch-to'

  $('['+schFrom+']').hover(function () {
    let that = $(this)
    let id = that.attr(schFrom)

    $('['+schFrom+'='+id+'], ['+schTo+'='+id+']').toggleClass('is-active')
  })


  if ( $('.rnd-svg') ) {
    setTimeout(function () {
      $('.asset').removeClass('is-disabled')
    }, 12000)
    setTimeout(function () {
      $('.cpi').removeClass('is-disabled')
    }, 18000)
  }

  $('.header__hamburger').click(function (e) {
    $(this).toggleClass('is-active')
    $('.header__subnav').toggleClass('is-active')
  })

  $('.header-subnav__item-dropdown p').click(function() {
    let that = $(this)
    that.parents('.header-subnav__item-dropdown').toggleClass('is-active')
  })

  // privacy check
  $('.feedback-form__agreement input').click(function (e) {
    if ( $('.feedback-form__submit').hasClass('is-disabled') ) {
      $('.feedback-form__submit').removeClass('is-disabled')
    } else {
      $('.feedback-form__submit').addClass('is-disabled')
    }
  })

  // select function
  window.setSelect = function () {
    var x, i, j, l, ll, selElmnt, a, b, c;
    /*look for any elements with the class "custom-select":*/
    x = document.getElementsByClassName("custom-select");
    l = x.length;
    for (i = 0; i < l; i++) {
      selElmnt = x[i].getElementsByTagName("select")[0];
      ll = selElmnt.length;
      /*for each element, create a new DIV that will act as the selected item:*/
      a = document.createElement("DIV");
      a.setAttribute("class", "select-selected");
      a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
      x[i].appendChild(a);
      /*for each element, create a new DIV that will contain the option list:*/
      b = document.createElement("DIV");
      b.setAttribute("class", "select-items select-hide");
      for (j = 1; j < ll; j++) {
        /*for each option in the original select element,
        create a new DIV that will act as an option item:*/
        c = document.createElement("DIV");
        c.innerHTML = selElmnt.options[j].innerHTML;
        c.addEventListener("click", function(e) {
          /*when an item is clicked, update the original select box,
          and the selected item:*/
          var y, i, k, s, h, sl, yl;
          s = this.parentNode.parentNode.getElementsByTagName("select")[0];
          sl = s.length;
          h = this.parentNode.previousSibling;
          for (i = 0; i < sl; i++) {
            if (s.options[i].innerHTML == this.innerHTML) {
              s.selectedIndex = i;
              h.innerHTML = this.innerHTML;
              y = this.parentNode.getElementsByClassName("same-as-selected");
              yl = y.length;
              for (k = 0; k < yl; k++) {
                y[k].removeAttribute("class");
              }
              this.setAttribute("class", "same-as-selected");
              break;
            }
          }
          h.click();
        });
        b.appendChild(c);
      }
      x[i].appendChild(b);
      a.addEventListener("click", function(e) {
        /*when the select box is clicked, close any other select boxes,
        and open/close the current select box:*/
        e.stopPropagation();
        closeAllSelect(this);
        this.nextSibling.classList.toggle("select-hide");
        this.classList.toggle("select-arrow-active");
      });
    }
    function closeAllSelect(elmnt) {
      /*a function that will close all select boxes in the document,
      except the current select box:*/
      var x, y, i, xl, yl, arrNo = [];
      x = document.getElementsByClassName("select-items");
      y = document.getElementsByClassName("select-selected");
      xl = x.length;
      yl = y.length;
      for (i = 0; i < yl; i++) {
        if (elmnt == y[i]) {
          arrNo.push(i)
        } else {
          y[i].classList.remove("select-arrow-active");
        }
      }
      for (i = 0; i < xl; i++) {
        if (arrNo.indexOf(i)) {
          x[i].classList.add("select-hide");
        }
      }
    }
    /*if the user clicks anywhere outside the select box,
    then close all select boxes:*/
    document.addEventListener("click", closeAllSelect);
  }

  // set select
  window.setSelect()

  // facility switch
  // $('.modal-itsm-facility-nav__button').click(function () {
  //   let that = $(this)
  //   let modal = that.parents('.modal-itsm-facility')
  //   let id = modal.attr('data-mm-popup')
  //   let num = parseInt(id.split('facility').pop())
  //   let next = ''
  //
  //   if ( that.hasClass('modal-itsm-facility-nav__button--next') ) {
  //     next = num + 1
  //   } else {
  //     next = num - 1
  //   }
  //
  //   next = 'facility' + next
  //
  //   modal.removeClass('is-active')
  //   $('.modal-itsm-facility[data-mm-popup='+ next +']').addClass('is-active')
  //
  // })

  //slider
  if ($('.case-slider')) {
    SwiperCore.use([Navigation])

    const swiper = new Swiper('.case-slider__container', {
      autoplay: {
        delay: 3500,
      },
      navigation: {
        prevEl: '.case-slider__nav--prev',
        nextEl: '.case-slider__nav--next',
        disabledClass: 'is-disabled'
      },
      speed: 1000
    })
  }

  if ($('.case-profit')) {
    $('.case-profit__likes, .case-profit__views').each(function () {
      $(this).click(e => {
        $(this).toggleClass('is-active')
      })
    })
  }
})
